import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
var _excluded = ["data"];
import _regeneratorRuntime from "@babel/runtime/regenerator";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { useQuery, useQueryClient } from 'react-query';
import api from 'utils/api';
import cancelFileNotification from 'utils/file/cancelFileNotification';
import { playlistQueryKeys } from 'actions/playlists';
import { FILE_STATUS_VALUES, fileQueryKeys } from 'actions/file';
function useFetchFileStatus(_ref) {
  var fileId = _ref.fileId,
    parentPlaylistId = _ref.parentPlaylistId,
    assetId = _ref.assetId,
    oldFileStatus = _ref.oldFileStatus,
    refetchInterval = _ref.refetchInterval,
    _ref$enabled = _ref.enabled,
    enabled = _ref$enabled === void 0 ? false : _ref$enabled,
    _ref$refetchIntervalI = _ref.refetchIntervalInBackground,
    refetchIntervalInBackground = _ref$refetchIntervalI === void 0 ? false : _ref$refetchIntervalI,
    _ref$cancelFileNotifi = _ref.cancelFileNotificationOnSuccess,
    cancelFileNotificationOnSuccess = _ref$cancelFileNotifi === void 0 ? false : _ref$cancelFileNotifi;
  var queryClient = useQueryClient();
  function fetchFile() {
    return _fetchFile.apply(this, arguments);
  }
  function _fetchFile() {
    _fetchFile = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var _yield$api, fileStatus;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            if (fileId) {
              _context.next = 2;
              break;
            }
            return _context.abrupt("return", null);
          case 2:
            _context.next = 4;
            return api('get', "/api/files/".concat(fileId), null);
          case 4:
            _yield$api = _context.sent;
            fileStatus = _yield$api.fileStatus;
            return _context.abrupt("return", fileStatus);
          case 7:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return _fetchFile.apply(this, arguments);
  }
  var _useQuery = useQuery({
      queryKey: fileQueryKeys.fileStatus(fileId),
      queryFn: fetchFile,
      staleTime: 5 * 60 * 1000,
      // If set to a number, all queries will continuously refetch at this frequency in milliseconds
      refetchInterval: enabled ? refetchInterval : false,
      // If set to true, queries that are set to continuously refetch with a refetchInterval will
      // continue to refetch while their tab/window is in the background
      refetchIntervalInBackground: refetchIntervalInBackground,
      // Disables the query from automatically running if set to false
      enabled: enabled,
      onSuccess: function onSuccess(data) {
        if (data && oldFileStatus !== data) {
          queryClient.invalidateQueries(['fetch-asset', {
            id: assetId
          }]);
          if (parentPlaylistId) {
            queryClient.invalidateQueries(playlistQueryKeys.singlePlaylistContent(parentPlaylistId));
          }
        }
        if (
        // Cancels the file notification email if the successfully fetched status is either 'ready' or 'invalid'
        cancelFileNotificationOnSuccess && (data === FILE_STATUS_VALUES.READY || data === FILE_STATUS_VALUES.INVALID) && fileStatus !== data) {
          cancelFileNotification({
            fileId: fileId
          });
        }
      }
    }),
    fileStatus = _useQuery.data,
    rest = _objectWithoutProperties(_useQuery, _excluded);
  return _objectSpread({
    fileStatus: fileStatus
  }, rest);
}
export default useFetchFileStatus;